import { DEFAULT_ITEMS_COUNT_PER_REQUEST } from '../constants/limits';

export const getSkipFirstForListing = (items: number, perRequest = DEFAULT_ITEMS_COUNT_PER_REQUEST) => (items - 1) * perRequest;
